import DOM from '@common/DOM/DOM'

const WEBFONT_API_URL = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js'

/** Dinamikusan betölti a webfontloadert. */
export default function createWebfontLoaderScript (): Promise<void> {
  return DOM.createScript(WEBFONT_API_URL)
}
